
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 64 64","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"1.414"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.597 29.266c1.822-1.824 2.734-4.024 2.734-6.6 0-2.575-.912-4.776-2.734-6.599-1.823-1.822-4.022-2.734-6.599-2.734-2.576 0-4.776.912-6.599 2.734-1.823 1.823-2.734 4.024-2.734 6.599 0 2.576.91 4.776 2.734 6.6C27.222 31.088 29.422 32 32 32c2.576 0 4.775-.912 6.598-2.734zm12.067-6.6c0 2.65-.401 4.825-1.203 6.526l-13.27 28.219a4.43 4.43 0 01-1.732 1.896 4.688 4.688 0 01-2.46.693 4.685 4.685 0 01-2.462-.693 4.198 4.198 0 01-1.696-1.896L14.534 29.192c-.802-1.701-1.203-3.876-1.203-6.526 0-5.152 1.823-9.551 5.468-13.198C22.446 5.822 26.845 4 32 4c5.15 0 9.551 1.823 13.196 5.47 3.647 3.646 5.47 8.045 5.47 13.197z","fill-rule":"nonzero"}})])
          )
        }
      }
    